import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, bufferTime, filter, map } from 'rxjs/operators';

import { AssociationService } from '@shared/services';

import {
  associationLabelGet,
  associationLabelGetFailure,
  associationLabelGetSuccess,
} from './association-label.actions';

@Injectable()
export class AssociationLabelEffects {
  getAssociationsLabel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(associationLabelGet),
      bufferTime(500),
      filter((arr) => arr.length > 0),
      mergeMap((associations: any[]) =>
        this.associationService
          .getLabelForMany(
            associations.map((asc) => ({ candidateId: asc.candidateId, reqId: asc.jobId })),
          )
          .pipe(
            map((payload) => associationLabelGetSuccess({ entities: payload })),
            catchError((error) => of(associationLabelGetFailure({ error }))),
          ),
      ),
    ),
  );

  constructor(private actions$: Actions, private associationService: AssociationService) {}
}
